import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Plus from '../assets/icons/feather/Plus.svg?react';

export function PlusIcon(props: SvgIconProps) {
  return <SvgIcon component={Plus} inheritViewBox {...props} />;
}
